/**
 * HeaderNavClose
 * ======================================
 * - close header on click
 */

const ELEMENTS = '.header-nav a'

class HeaderNavClose {
  constructor() {
    this.elements = document.querySelectorAll(ELEMENTS)

    if (!this.elements) {
      return false
    }

    this.elements.forEach(el => {
     if(el.getAttribute('href').includes('#')){
       el.addEventListener('click', this.close, false)
     }
    })
  }

  close = (e) => {
     document.body.classList.remove('nav-is-open')
  }
}

new HeaderNavClose()
